/* app/js/src/components/mam-explorer/mam-explorer-select-all-header/mam-explorer-select-all-header.component.scss */
:host {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=mam-explorer-select-all-header.component.css.map */
